// home-videos-01 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "Ativar som": "Activar sonido",
    "Clube de Vantagens: desconto de combustível vendido por Pix": "Club de Beneficios: descuento de combustible vendido por Pix",
    "Clube de Vantagens: código de divulgação que mede cada campanha": "Club de Beneficios: código de promoción que mide cada campaña",
    "Desativar som": "Desactivar sonido",
    "Sorteio: cadastro no app vale número da sorte": "Sorteo: el registro en la app vale un número de la suerte",
};

export default catalogo;
